<template lang="pug">
  f7-actions(
    :opened="opened"
    @actions:closed="$emit('actions:closed')"
  )
    f7-actions-group
      f7-actions-label 編集内容を破棄しますか？
      f7-actions-button(@click="$f7router.back()" color="red") 破棄する
    f7-actions-group
      f7-actions-button Cancel
</template>

<script>
export default {
  props: {
    opened: { type: Boolean },
  },
}
</script>
